import store from "@/store";
import { SiteModel } from "@/models/SiteModel";
import FallbackDB from "@/libraries/localStorage";
import { addMagicMethods } from "@/helpers/addMagicMethods";
export class ShiftModel extends SiteModel {
    constructor(id = null) {
        super('shifts', +id);
        return addMagicMethods(this);
    }
    getTableData() {
        return store.getters['shifts/getShifts'] || [];
    }
    setTableData(data) {
        store.commit('shifts/setShifts', data);
        FallbackDB.save('shifts', data);
    }
    static onSuccessSubmit(response) {
        return super.onSuccessSubmit('ShiftModel', response);
    }
    flush() {
        return super.flush('ShiftModel', 'shifts');
    }
    __get(target, prop, receiver) {
        switch (prop) {
            case 'is_done':
                return +receiver.status === ShiftModel.STATUS_DONE;
            default:
                return super.__get(target, prop, receiver);
        }
    }
    __set(target, prop, value, receiver) {
        switch (prop) {
            case 'is_done':
                receiver.status = !!value ? ShiftModel.STATUS_DONE : ShiftModel.STATUS_CREATED;
                break;
            default:
                super.__set(target, prop, value, receiver);
        }
        return true;
    }
    find(params) {
        let list = (new ShiftModel()).getList();
        if (params.is_done !== undefined) {
            list = list.filter(v => +v.is_done === +params.is_done);
        }
        return list;
    }
}
ShiftModel.STATUS_CREATED = 0;
ShiftModel.STATUS_DONE = 2;
window.ShiftModel = ShiftModel;
